import AbstractInstaller from "../../core/application/AbstractInstaller";
import SkinKeyRegistry from "../../core/ui/SkinKeyRegistry";
import ProblemLinkingCommandEvent from "./controller/ProblemLinkingCommandEvent";
import ProblemLinkingFeedbackCommand from "./controller/ProblemLinkingFeedbackCommand";
import ProblemLinkingFeedbackMediator from "./view/ProblemLinkingFeedbackMediator";
import ProblemLinkingMediator from "./view/ProblemLinkingMediator";

export default class ProblemLinkingInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        commands.add(ProblemLinkingCommandEvent.PROBLEM_LINKING_SUBMITTED, ProblemLinkingFeedbackCommand);
        
        SkinKeyRegistry.PROBLEM_LINKING_SCREEN_SKIN = this._mapMediator(ProblemLinkingMediator, lib.MainAssets.ProblemLinkingScreenSkin);
        SkinKeyRegistry.PROBLEM_LINKING_FEEDBACK_SCREEN_SKIN = this._mapMediator(ProblemLinkingFeedbackMediator, lib.MainAssets.ProblemLinkingFeedbackScreenSkin);

        //startup tasks: none
    }
}